import { RESPONSIVE_BREAKPOINTS } from 'constants/Global/ResponsiveLayout.const';
import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;

  @media (min-width: ${RESPONSIVE_BREAKPOINTS.tablet}px) {
    gap: 12px;
  }
`;

export const Heading = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #262626;

  @media (min-width: ${RESPONSIVE_BREAKPOINTS.tablet}px) {
    font-size: 22px;
  }
`;

export const Subtitle = styled.span`
  font-size: 12px;
  color: #595959;
`;

export const IconButton = styled.button`
  position: relative;
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  padding: 0;
  font-size: 18px;
  color: #262626;
  cursor: pointer;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;

  &:disabled {
    color: #bfbfbf;
    cursor: not-allowed;
    background: #f5f5f5;
  }

  &[data-active='true']::after {
    position: absolute;
    top: 6px;
    right: 6px;
    width: 8px;
    height: 8px;
    content: '';
    background: #f78e1e;
    border-radius: 50%;
  }
`;

export const FilterButton = styled(IconButton)`
  color: #fff;
  background: #f78e1e;
  border-color: #f78e1e;

  &:hover {
    background: #f9a54b;
    border-color: #f9a54b;
  }

  &[data-active='true']::after {
    background: #fff;
  }
`;
